import Icon from '../../../components/AppIcon';
import { ROIMetric } from '../types';

interface TrustBadgesProps {
  metrics: ROIMetric[];
}

const TrustBadges = ({ metrics }: TrustBadgesProps) => {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="bg-card rounded-xl border border-border p-6 text-center hover:shadow-md transition-shadow duration-fast"
        >
          <div className="inline-flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full mb-4">
            <Icon name={metric.iconName} size={24} className="text-primary" />
          </div>
          <div className="text-3xl font-bold text-text-primary mb-2">{metric.value}</div>
          <div className="text-sm font-semibold text-text-primary mb-1">{metric.label}</div>
          <div className="text-xs text-text-secondary">{metric.description}</div>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;